import { render, staticRenderFns } from "./MbCoding.vue?vue&type=template&id=edf70846&scoped=true&"
import script from "./MbCoding.vue?vue&type=script&lang=js&"
export * from "./MbCoding.vue?vue&type=script&lang=js&"
import style0 from "./MbCoding.vue?vue&type=style&index=0&id=edf70846&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf70846",
  null
  
)

export default component.exports